module.exports = __webpack_public_path__ + "img/patchs.d04474e2.svg";